module.exports = __webpack_public_path__ + "static/Truck16-9880953d359b2f56f58138462f5e42a2.png";